import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRequestAccessModalFooter = props => {
  const {
    onCancel,
    onSend,
    sendButtonDisabled
  } = props;
  return /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(Button, {
      "data-test-id": "product-approvals-request-access-submit-button",
      disabled: sendButtonDisabled,
      use: "primary",
      onClick: onSend,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.sendRequest"
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onCancel,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.cancel"
      })
    })]
  });
};
export default ApprovalRequestAccessModalFooter;